module.exports = __webpack_public_path__ + "img/portrait-003.03f582da.jpg";